export var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["IDLE"] = "idle";
    RecordingStatus["REQUESTING_PERMISSION"] = "requesting_permission";
    RecordingStatus["RECORDING"] = "recording";
    RecordingStatus["STOPPED"] = "stopped";
    RecordingStatus["ERROR"] = "error";
})(RecordingStatus || (RecordingStatus = {}));
